/* eslint-disable i18next/no-literal-string -- scope-mode discriminant, not user-visible text */

/** Scope authoring sub-mode for the certification policy wizard (spec §7.2). */
export const ScopeMode = {
    CONDITIONS: 'conditions',
    EXPRESSION: 'expression',
} as const

export type ScopeMode = (typeof ScopeMode)[keyof typeof ScopeMode]
